import { useTranslatedKey } from "@helpers/useTranslatedKey";
import { useTranslation } from "@helpers/useTranslation";
import { FC } from "react";

type Props = {
  challenge: OracleChallenge;
  eventId: string;
  teamId: string;
};

/**
 * Guest view of an oracle challenge. There is nothing to submit, and the challenge is never marked
 * "completed" — it is done in person at a booth where an associate awards the points (which show up
 * in the team's total). We just show the brief and a prompt to find an associate.
 */
export const OracleChallenge: FC<Props> = ({ challenge }) => {
  const { t } = useTranslation("challenges");
  const { getTranslatedValue } = useTranslatedKey();
  const title = getTranslatedValue(challenge, "title");
  const copy = getTranslatedValue(challenge, "copy");

  const isUrbostogosPagundaChallenge = title?.startsWith("PAGUNDA");

  return (
    <div className="mt-4 mb-8 flex flex-col items-center">
      <h1 className="mx-4 mt-12 mb-8 text-center text-4xl font-semibold">{title}</h1>
      <div className="mx-6 flex max-w-lg flex-col justify-center">
        <p className="text-md mt-4 mb-6 whitespace-pre-line text-center">{copy}</p>

        {isUrbostogosPagundaChallenge ? (
          <div className="rounded-lg border-2 border-dashed border-base-300 px-4 py-6 text-center">
            <div className="text-2xl">📍</div>
            <p className="text-md mt-2 font-semibold">{t("oracleFindAssociatePagunda")}</p>
          </div>
        ) : (
          <div className="rounded-lg border-2 border-dashed border-base-300 px-4 py-6 text-center">
            <div className="text-2xl">📍</div>
            <p className="text-md mt-2 font-semibold">{t("oracleFindAssociate")}</p>
            <p className="mt-1 text-sm text-gray-500">{t("oracleBoothHint")}</p>
          </div>
        )}
      </div>
    </div>
  );
};
